<template>
  <div class="form-input-image">
    <div class="mb-4" v-if="value && !upload.inProgress && !hideImage">
      <img :src="value" class="max-w-full" :style="imageStyle" />
    </div>

    <template v-if="acceptSvg">
      <button
        type="button"
        class="btn-default"
        @click="$refs.fileInput.click()"
        :disabled="disabled"
        v-if="!upload.inProgress"
      >
        {{ value ? 'Sostituisci' : 'Scegli' }}
      </button>
      <template v-else>
        <p v-if="upload.preparing">Caricamento...</p>
        <p v-else>Progresso: {{ upload.progressPercent }}%</p>
      </template>
      <input
        type="file"
        :id="id"
        :name="name"
        class="hidden"
        ref="fileInput"
        @change="handleFile"
        accept="image/*"
      />
    </template>
    <template v-else>
      <Uppload
        :width="imageWidth"
        :height="imageHeight"
        :uploader="uploadImage"
        :defaultCrops="isVisualElement"
        :disable-crop="disableCrop"
      >
        <template v-if="!upload.inProgress">
          <div class="flex">
            <button type="button" class="btn-default" :disabled="disabled">
              <span v-if="label === ''">
                {{ value ? 'Sostituisci' : 'Scegli' }}
              </span>
              <span v-else>{{ label }}</span>
            </button>
            <slot name="buttons"></slot>
          </div>
        </template>
        <template v-else>
          <p v-if="upload.preparing">Preparing...</p>
          <p v-else>Uploading: {{ upload.progressPercent }}%</p>
        </template>
      </Uppload>
    </template>

    <p v-if="upload.error">{{ upload.error.message }}</p>
  </div>
</template>

<script>
import Uppload from './Uppload'

import S3Upload from '@/mixins/S3Upload'

export default {
  mixins: [S3Upload],
  components: {
    Uppload,
  },
  props: {
    id: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      default: '',
    },

    value: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    podcastId: {
      type: String,
      required: true,
    },

    imageWidth: {
      type: Number,
      default: 1,
    },

    imageHeight: {
      type: Number,
      default: 1,
    },
    isVisualElement: {
      type: Boolean,
      default: false,
    },
    acceptSvg: {
      type: Boolean,
      default: false,
    },
    hideImage: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    disableCrop: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      imageStyle: '',
    }
  },
  mounted() {
    if (this.imageWidth !== 1 && this.imageHeight !== 1 && !this.disableCrop) {
      this.imageStyle =
        'max-height:clamp(100px, ' +
        this.imageHeight +
        'px, 30vh); max-width: 100%;'
    }
  },
  methods: {
    handleFile({ target }) {
      if (!target.validity.valid) return
      this.uploadImage(target.files[0])
    },
    uploadImage(file) {
      if (!file || !file.type.match(/image\/(?:.+)/)) {
        this.upload.error = new Error('Invalid file type')
        return
      }
      this.uploadFile(file).then(readUrl => {
        this.$emit('img_size', [this.imageWidth, this.imageHeight])
        this.$emit('input', readUrl)
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
